import React from "react";
import { HeartHandshake, Users } from "lucide-react";
import { useApi } from "../hooks/useApi";
import { useLang } from "../i18n/LanguageContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "./ui/dialog";
import { AuthImage } from "./FileUpload";

function Attendees({ eventId }) {
  const { t } = useLang();
  const { data } = useApi(`/events/${eventId}/attendees`, [eventId]);
  if (!data) return <p className="text-sm text-muted-foreground">{t("Loading…")}</p>;
  if (data.length === 0) return <p className="text-sm text-muted-foreground" data-testid="attendees-empty">{t("No one has RSVP'd yet — be the first and share it!")}</p>;
  return (
    <ul className="max-h-80 space-y-2 overflow-y-auto" data-testid="attendees-list">
      {data.map((a) => (
        <li key={a.member_id} className="flex items-center gap-3 rounded-lg border border-gold/20 bg-parchment-card p-2" data-testid={`attendee-${a.member_id}`}>
          <div className="flex h-9 w-9 shrink-0 items-center justify-center overflow-hidden rounded-full bg-gold-light text-sm font-bold text-crimson">
            {a.photo_url ? <AuthImage src={a.photo_url} alt={a.name} className="h-full w-full object-cover" /> : a.name.charAt(0)}
          </div>
          <span className="text-sm font-semibold">{a.name}{a.is_me && <span className="ml-1 text-xs text-gold">({t("you")})</span>}</span>
        </li>
      ))}
    </ul>
  );
}

export function RsvpBadge({ event }) {
  const { t } = useLang();
  return (
    <Dialog>
      <DialogTrigger asChild>
        <button className="mt-1 inline-flex items-center gap-1 rounded-full bg-palm/10 px-2 py-0.5 text-xs font-semibold text-palm transition-colors hover:bg-palm hover:text-parchment" data-testid={`rsvp-count-${event.id}`}>
          <HeartHandshake size={12} /> {event.rsvp_count || 0} {t("going")}
        </button>
      </DialogTrigger>
      <DialogContent data-testid="attendees-dialog">
        <DialogHeader><DialogTitle className="flex items-center gap-2 font-serif-display text-crimson"><Users size={18} className="text-gold" /> {t("Who's going")} · {event.title}</DialogTitle></DialogHeader>
        <Attendees eventId={event.id} />
      </DialogContent>
    </Dialog>
  );
}
